'use strict';
var $ = require('../internals/export');
var addToUnscopables = require('../internals/add-to-unscopables');
var uniqueBy = require('../internals/array-unique-by');

// `Array.prototype.uniqueBy` method
// https://github.com/tc39/proposal-array-unique
$({ target: 'Array', proto: true }, {
  uniqueBy: uniqueBy
});

addToUnscopables('uniqueBy');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/esnext.array.unique-by.js
// module id = 937
// module chunks = 1 2 3 4